import { ChooseNumberAction } from '../actions/ChooseNumberAction';
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const initState = {
    requestBody: {
        sectionId: "ChooseNumber",
        steps: [
            {
                sequence: "0",
                offerContainerId: "",
                stepId: "ChooseNumber",
                fields: [
                    {
                        name: "GetMSISDNListResponse",
                        value: ""
                    },
                    {
                        name: "ReserveMSISDNResponse",
                        value: ""
                    },
                    {
                        name: "SelectedMSISDN",
                        value: ""
                    },
                    {
                        name: "SelectedMSISDNReservationID",
                        value: ""
                    }
                ]
            }
        ]
    },
    fetchMsisdnResponse: {

    },
    reserveMsisdnResponse: {

    }
}


const ChooseNumberReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var ChooseNumberValue = { ...state.requestBody.steps };

    switch (type) {

        case ChooseNumberAction.FETCH_MSISDN_SUCCESS:
            return { ...state, fetchMsisdnResponse: payload };

        case ChooseNumberAction.RESERVE_MSISDN_SUCCESS:  
            ChooseNumberValue[0].offerContainerId = payload.offerContainerId;
            ChooseNumberValue[0].fields[0].value = payload.numbersList.map((num:any)=> { return num.id}).join();
            ChooseNumberValue[0].fields[1].value = JSON.stringify(payload.response.data);
            ChooseNumberValue[0].fields[2].value = payload.selection;
            ChooseNumberValue[0].fields[3].value = payload.response?.data?.MSISDN_spcId;

            return { ...state, reserveMsisdnResponse: payload.response };

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, fetchMsisdnResponse: {}, reserveMsisdnResponse: {} };

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'ChooseNumber')
            });
            if(section.length > 0) {
                ChooseNumberValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                for (let i = 0; i < ChooseNumberValue[0].fields.length; i++) {
                    const ChooseNumberField = section[0].steps[0].fields.filter((field: any) => { return (field.name === ChooseNumberValue[0].fields[i].name) })[0];
                    ChooseNumberValue[0].fields[i].value = ChooseNumberField ? ChooseNumberField.value : "";
                }
            }
            return state;

        default:
            return state;
    }
}

export default ChooseNumberReducer;